const sizes = {
    footerT: 6,
    min: 8,
    small: 10,
    xsmall: 12,
    xxsmall: 14,
    xxxsmall: 16,
    medium: 18,
    xmedium: 20,
    xxmedium: 22,
    xxxmedium: 24,
    large: 26,
    xlarge: 28,
    xxlarge: 32,
    xxxlarge: 34,
    initial: 36,
    xxsuper: 40,
    titlle: 42,
    xtitlle: 44,
    titleInitla: 48,
    xxtitle: 54,
    xxxtitle: 60,
    eith: 68,
    xsuper: 80,
    super: 100,
    xxxsuper: 240,
}

export const fontSizes = Object.values(sizes) as never

Object.keys(sizes).map((key, index) => {
    fontSizes[key] = fontSizes[index]
    return {
        [key]: index,
    }
})
